<template>
  <el-dialog 
        :title="titleVisible" 
        :visible.sync="visible" 
        width="65%" 
        @close="closeHandle" 
        modal-append-to-selector='body' 
        append-to-selector="body"
    >
    <el-form :model="categoryRelationsList" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="适配店铺" prop="shopId">
         <el-select 
            v-model="categoryRelationsList.shopId"
            placeholder="请选择店铺" 
            clearable
            filterable
            remote
            :disabled="visibleType == 'EDIT'"
            width="200px"
            >
            <el-option
                v-for="shopItem in shopList"
                :key="shopItem.id"
                :label="shopItem.shortTitle || shopItem.title"
                style="width: 150px;"
                :title="shopItem.shortTitle || shopItem.title"
                :value="shopItem.id">
            </el-option>
        </el-select>

        <span v-if="visibleType == 'ADD'" style="font-size: 12px;color: #FF6701;line-height: 14px;margin-left: 8px;">
          <i class="el-icon-warning" style="color: #FF6701; font-size: 14px"></i>
          注意：切换店铺后，将重置本次类目例外配置，请小心操作
        </span>
        <!-- <el-input style="width: 60%" v-model="ruleForm.name" aria-placeholder="请选择店铺"></el-input> -->
      </el-form-item>
      <el-row v-if="categoryRelationsList.shopId">
          <el-col :span="24">
          <el-form-item label="">
              <el-table :data="categoryRelationsList.relations" :border=true style="width: 99.99%;">
                  <!-- <el-table-column type="index" label="序号" width="100"></el-table-column> -->
                  <el-table-column prop="name" label="适用类目" width="150">
                      <template slot-scope="{ row, $index }">
                           <span>{{ (row.parentCategoryNames || []).join(',')  }}</span>
                            <el-link @click="editCategoryClick(row,initCateData,$index)">
                                <i v-if="row.categoryId" class="el-icon-edit-outline el-link el-link--primary"></i>
                                <span v-else>选择类目</span>
                            </el-link>
                      </template>
                  </el-table-column>
                  <el-table-column prop="name" label="品牌" width="300">
                      <template slot-scope="scope">
                       <el-select 
                            v-model="scope.row.vid" 
                            placeholder="请选择品牌" 
                            clearable
                            filterable
                            :remote="isRemote"
                            :remote-method="query => getBrandList(scope.row.categoryId, categoryRelationsList.shopId, true, query)"
                            :disabled="!scope.row.categoryId"
                            @focus="getBrandList(scope.row.categoryId, categoryRelationsList.shopId, true, '')"
                            width="180px"
                            @change="(value)=>handleBrandChange(scope.row,value)"
                            >
                            <el-option
                                v-for="brand in shopBrands[categoryRelationsList.shopId + '_' + scope.row.categoryId]"
                                :key="brand.vid"
                                :label="brand.vvalue"
                                style="width: 150px;"
                                :title="brand.vvalue"
                                :value="brand.vid">
                            </el-option>
                        </el-select>
                        <!-- <el-link v-if="scope.row.categoryId" style="margin-left: 8px" @click="handleRefreshBrand(scope.row.categoryId)">刷新品牌</el-link> -->
                      </template>
                  </el-table-column>
                    <el-table-column v-if="visibleType !== 'EDIT'" label="操作" width="60">
                        <template slot-scope="scope">
                            <el-button size="mini" type="default"  plain @click="addmembers">添加配置</el-button>
                            <el-button size="mini" type="danger" plain @click="delmembers(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
              </el-table>
            </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCategoryCancel">取 消</el-button>
      <el-button type="primary" @click="handleCategorySave('ruleForm')">确 定</el-button>
    </span>
    <CascaderDialog :platform="platform" ref="CascaderDialog" />

  </el-dialog>
</template>

<script>
import CascaderDialog from '../../center/components/PlatformCategoryInput/CascaderDialog.vue'
// import { getBrandListPlatForm, refreshBrand } from '@/servers/prod/center/fxg.js';
// import { getPddBrandList } from '@/servers/prod/center/pdd.js';
// import { getVenderBrandListByshopId } from '@/servers/prod/center/jd.js'
import { getPlatFormBrandList, refreshPlatFormBrand } from '@/api/prod/center'

import { cloneDeep } from 'lodash';

export default {
  props:{
    shopList: {
      type: Array,
      default: []
    },
    brandData: {
      type: Array,
      default: []
    },
    platform: {
      type: String,
      default: ''
    },
  },
  components: {
    CascaderDialog,
  },
  provide: {
    isBatchCategory: true,
  },
  computed: {
    isRemote() {
      return this.platform === 'wxsph' ? false : true
    }
  },
  data() {
    return {
      visible: false,
      visibleType:'ADD',
      shopBrands:[],
      shopBrandCatagorys:{},
      rules: {
        shopId: [
          { required: true, message: '请选择店铺', trigger: 'blur' },
        ],
      },
      categoryRelationsList:{
        shopId:'',
        shopName:'',
        relations: []
      },
      curShop: {},
      initData: {
        shopId:'',
        shopName:'',
        relations: []
      },
      initCateData:{
          categoryId: '',
          // 品牌
          vvalue: '',
          vid: '',

          templatePid: '',
          refPid: 310,
          valueUnit: '',

          parentCategoryIds: [],
          parentCategoryNames: []
      },
      titleVisible: '新增类目例外配置',
    };
  },
  watch: {
    'categoryRelationsList.shopId': {
        handler(newData,oldVal) {
          let curShop = {}
          if (newData) {
            if(!this.categoryRelationsList.relations.length){
                this.initShopBrandConf(this.categoryRelationsList);
            }
            curShop = this.shopList.find(shop => shop.id == newData)
          }
          if(oldVal && this.categoryRelationsList.relations.length){
            this.categoryRelationsList.relations = [
              {
                categoryId: '',
                // 品牌
                vvalue: '',
                vid: '',

                templatePid: '',
                refPid: 310,
                valueUnit: '',

                parentCategoryIds: [],
                parentCategoryNames: []
              }
            ]
          }
          this.curShop = curShop
        },
        deep: true,
        immediate: true
    },
    visibleType:{
      handler(newData) {
            if (newData == 'EDIT') {
               this.titleVisible = '编辑类目例外配置'
            } else {
              this.titleVisible = '新增类目例外配置'
            }
        },
        deep: true,
    }
  },
  methods: {
    closeHandle() {
      this.categoryRelationsList ={
        shopId:'',
        shopName:'',
        relations: []
      }
      this.visible = false
    },
    async method_open({ visibleType,categoryRow }, cb) {
      const _categoryRow = cloneDeep(categoryRow)
      this.resetInfo();
      this.visibleType = visibleType
      this.cb = cb;
      this.visible = true;
      if(visibleType =='EDIT'){
        this.categoryRelationsList.shopId = _categoryRow.parent.shopId;
        this.curShop = this.shopList.find(shop => shop.id == this.categoryRelationsList.shopId) || {}
         this.initShopBrandConf(_categoryRow)
         await this.getBrandList(_categoryRow.categoryId, _categoryRow.parent.shopId,true)
         // 确保品牌列表加载完成后，回显已选品牌
         const brandKey = `${_categoryRow.parent.shopId}_${_categoryRow.categoryId}`
         if(_categoryRow.vid) {
           const brandList = this.shopBrands[brandKey] || []
           const findBrand = brandList.find(item => item.vid == _categoryRow.vid)
           if(findBrand) {
             this.$set(this.categoryRelationsList.relations[0], 'vid', findBrand.vid)
             this.$set(this.categoryRelationsList.relations[0], 'vvalue', findBrand.vvalue)
           } else if(_categoryRow.vvalue) {
             // 不在当前分页中，手动添加到列表以保证回显
             brandList.unshift({
               vid: _categoryRow.vid,
               vvalue: _categoryRow.vvalue,
               refPid: 310,
             })
             this.shopBrands = { ...this.shopBrands, [brandKey]: [...brandList] }
           }
         }
      }
    },
    // 快手退货选项变更
    updateRefundRule(newRefundRule) {
      this.ksRefundRule = newRefundRule.length ? newRefundRule[0] : '';
    },
    // 将组件相关数据初始化
    resetInfo() {
    },
    addmembers() {
      this.categoryRelationsList.relations?.push({
        categoryId: '',
          // 品牌
          vvalue: '',
          vid: '',

          templatePid: '',
          refPid: 310,
          valueUnit: '',

          parentCategoryIds: [],
          parentCategoryNames: []
      })
    },

    delmembers(index, row) {
      var that = this;
      this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      }).then(() => {
            that.categoryRelationsList.relations.splice(index, 1);
            this.$message({ message: '删除成功', duration: 2000, type: 'success' });
        }).catch(() => {
        //点取消的提示
            return;
        });
    },
     // 品牌设置 - 修改类目
     editCategoryClick(brandCatagory, shopBrandCatagorys,index) {
            const shopBrandConfCategory = this.brandData.filter(i=>i.parent.shopId === this.categoryRelationsList.shopId)
            const categoryIdList = shopBrandConfCategory.map(item => item.categoryId);
            this.$refs.CascaderDialog.method_open(brandCatagory.parentCategoryIds || [], res => {
                const [categoryIds=[], labels=[]] = res;
                const categoryId = categoryIds[categoryIds.length-1];
                brandCatagory.parentCategoryIds = categoryIds;
                brandCatagory.categoryId = categoryId;
                brandCatagory.vid = '';
                brandCatagory.parentCategoryNames = labels;
            }, categoryIdList)
        },

      async getBrandList(categoryId='', shopId, isTrue = true, query = '') {
          if(!isTrue && !shopId) return;
          if(!categoryId) {
              this.$message({
                  message: '请先选择类目',
                  type: 'warning'
              });
              return
          }
          const platformMaps = {
            fxg: {
              url: '/fxg/brandListV2',
              categoryIdKey: 'categoryLeafId',
              idKey: 'vid',
              valueKey: 'name',
            },
            pdd: {
              url: '/pdd/getBrandList',
              categoryIdKey: 'leafCategoryId',
              idKey: 'vid',
              valueKey: 'value',
            },
            jd: {
              url: '/jd/getVenderBrandByShopIdAndCategoryId',
              categoryIdKey: 'categoryId',
              idKey: 'erpBrandId',
              valueKey: 'brandName',
              queryKey: 'brandName'
            },
            kuaishou: {
              url: '/kuaishou/brandList',
              categoryIdKey: 'categoryLeafId',
              idKey: 'vid',
              valueKey: 'name',
            },
            wxsph: {
              url: '/wxsph/getBrandValidList',
              idKey: 'brandId',
              valueKey: 'chName',
            },
            xhs: {
              url: '/xhs/brandSearch',
              idKey: 'id',
              valueKey: 'name',
              categoryIdKey: 'categoryLeafId',
            },
          }
          const platform = this.platform || this.curShop.source
          let params = {
              [platformMaps[platform].categoryIdKey]: categoryId,
              shopId,
              [platformMaps[this.platform].queryKey || 'query']: query,
              platform,
          }
          if(platform == 'wxsph'){
            params = {
              userId: this.$store.getters.shops_getById(shopId)?.userId || '',
              pageSize: 500,
            }
          } else if(platform == 'xhs') {
            params.keyword = query
          }

      
          const res = await getPlatFormBrandList(params, platformMaps[platform].url)
          if(!res) return;
          let brandOptionList = res.data || []
          if(['fxg', 'kuaishou', 'fxg_gx'].includes(platform)){
            brandOptionList = res?.data[0]?.brandList || []
          } else if(['wxsph', 'xhs'].includes(platform)){
            brandOptionList = res?.data?.brands || []
          } 
          let list = brandOptionList.map(item => {
            let valueKey = platformMaps[platform].valueKey
            let vvalue = ''
            if(Array.isArray(valueKey)) {
              vvalue = item[valueKey[0]] || item[valueKey[1]]
            } else {
              vvalue = item[valueKey]
            }
            return {
              vid: item[platformMaps[platform].idKey],
              vvalue,
              valueUnit: '', 
              templatePid: '',
              refPid: 310
            }
          })
          if(['jd', 'wxsph'].includes(platform)){
            const findNoBrand = list.find(item => item.vid == -1 || item.vvalue === '无品牌')
            if(!findNoBrand) {
                list.unshift({
                    vid: -1,
                    vvalue: '无品牌',
                    refPid: 310
                })
            }
          }
          console.log(list, '---queryKey---')
          this.$set(this.shopBrands, shopId + '_' + categoryId, list);
          return 
      },
      handleBrandChange(row,value){
        row.vvalue = this.shopBrands[`${this.categoryRelationsList.shopId}_${row.categoryId}`].find(item=>item.vid == row.vid).vvalue
      },
      async handleRefreshBrand(categoryId) { 
        const userId = this.shopList.find(item=>item.id == this.categoryRelationsList.shopId)?.userId
        if(!userId) return this.$message.warning('请先选择店铺！')
        const refreshBrandUrls = {
          fxg: '/fxg/refreshBrand',
          kuaishou: '/kuaishou/refreshBrand',
        }
        const res = await refreshPlatFormBrand({
          userId, 
          categoryId
        }, refreshBrandUrls[this.platform])
        if(res.result === 1) {
          this.$message.success('更新品牌成功！')
        }
      },
      initShopBrandConf(categoryBrandRelations) {
        if(this.visibleType == 'ADD'){
          this.categoryRelationsList.relations?.push({
              categoryId: '',
              // 品牌
              vvalue: '',
              vid: '',

              templatePid: '',
              refPid: 310,
              valueUnit: '',

              parentCategoryIds: [],
              parentCategoryNames: []
            })
        } else {
          this.categoryRelationsList?.relations?.push(categoryBrandRelations)
        }
      },

      handleCategorySave(formName){
        this.$refs[formName].validate((valid) => {
        if (valid) {
          // 类目不能为空，并且品牌不能为空
          if(this.categoryRelationsList.relations.length == 0 ){
            return this.$message.warning('请选择类目，类目不能为空！')
          }
          if(this.categoryRelationsList.relations.filter(item=>item.vid == '').length >=1){
            return this.$message.warning('请选择品牌，品牌不能为空！')
          }
            this.$emit('update-relations', {payload:Object.assign({},this.categoryRelationsList),payloadType:this.visibleType})
            this.closeHandle()
          } else {
            return false;
          }
        });
      },

      handleCategoryCancel(){
        this.closeHandle()
      },

  },
  mounted(){
  },
};
</script>

<style lang="scss" scoped>
.base {
  padding: 0 18px;
  ::v-deep .el-cascader {
    width: 755px !important;
  }
}
</style>